import { render, staticRenderFns } from "./acceptApproval.vue?vue&type=template&id=5a7ea91c&scoped=true&"
import script from "./acceptApproval.vue?vue&type=script&lang=js&"
export * from "./acceptApproval.vue?vue&type=script&lang=js&"
import style0 from "./acceptApproval.vue?vue&type=style&index=0&id=5a7ea91c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ea91c",
  null
  
)

export default component.exports